export const listingPath = (item) => `/listing/${item?.slug || item?.id || ""}`;
export const categoryPath = (cat) => `/category/${cat?.slug || cat?.id || ""}`;
